import {Component, OnInit, ViewChild} from '@angular/core';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {TaskTypeConfigurationService} from './task-type-configuration.service';
import {CfgTaskConfigurationListModel} from '../../../models/configuration/cfg-task-configuration-list.model';
import {MatTableDataSource} from '@angular/material/table';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {DataSource} from '@angular/cdk/collections';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {CfgTaskTypeAutoDestinationListModel} from '../../../models/configuration/cfg-task-type-autodestination-list.model';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {TdoUserGroupConfigurationModel} from '../../../models/configuration/user/tdo-user-group-configuration.model';
import {UserService} from '../../../services/user.service';
import {TaskTypeGroupDialogComponent} from './task-type-group-dialog/task-type-group-dialog.component';
import {TaskTypeUserDialogComponent} from './task-type-user-dialog/task-type-user-dialog.component';
import {TdoConfigurationActionBarComponent} from '../../../tdo-controls/common/tdo-configuration-action-bar/tdo-configuration-action-bar.component';
import {ConfigurationService} from '../configuration.service';
import {CfgTaskConfigurationModel} from '../../../models/configuration/cfg-task-configuration.model';

export class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  UserTaskType: string;
  actions = [TdoTableActionsEnum.DELETE];
  model: CfgTaskConfigurationListModel;

  getActionTooltip(actionName: string): string {
    return `Delete ${this.UserTaskType}`;
  }
}

export class TableViewDataDestinations extends TdoTableBaseItemModel implements ITdoTableItemModel {
  User: TdoUserConfigurationModel;
  UserGroup: TdoUserGroupConfigurationModel;
  Type: string;
  Destination: string;
  actions = [TdoTableActionsEnum.DELETE];
  model: CfgTaskTypeAutoDestinationListModel;

  getActionTooltip(actionName: string): string {
    return `Delete`;
  }
}

@Component({
  selector: 'app-task-type-configuration',
  templateUrl: './task-type-configuration.component.html',
  styleUrls: ['./task-type-configuration.component.scss']
})
export class TaskTypeConfigurationComponent implements OnInit {
  @ViewChild('taskTypeTable') taskTypeTable: TdoTableComponent;
  @ViewChild('taskTypeDestinationsTable') taskTypeDestinationsTable: TdoTableComponent;
  @ViewChild('actionBar') actionBar: TdoConfigurationActionBarComponent;

  clientList: TdoClientConfigurationModel[];
  locationList: ClientLocationDataModel[];
  taskTypeList: CfgTaskConfigurationListModel[];
  taskTypeDestinationList: CfgTaskTypeAutoDestinationListModel[];

  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  selectedTaskType: CfgTaskConfigurationListModel;
  selectedTaskTypeRevert: CfgTaskConfigurationListModel;
  editedTaskTypes: CfgTaskConfigurationListModel[] = [];
  selectedTaskTypeDestinations: CfgTaskTypeAutoDestinationListModel[];
  userGroups: TdoUserGroupConfigurationModel[];
  users: TdoUserConfigurationModel[];

  taskTypeEnums: EnumValidValueItemModel[] = [];
  taskTimeCalculationEnums: EnumValidValueItemModel[] = [];
  enumTaskTimeCalculationIDDelay = '00000249-1000-0000-0000-000000000001';
  enumTaskTimeCalculationIDLead = '00000249-1000-0000-0000-000000000002';
  enumTaskTimeCalculationIDNone = '00000249-1000-0000-0000-000000000003';
  calculationLabel: string = '';

  // task types
  tableModel: TdoTableModel;
  tableViewData: TableViewData[];
  displayedColumns: string[] = ['UserTaskType', 'actions'];
  displayedColumnsLabels: string[] = ['Task Type'];
  dataSource: DataSource<TableViewData>;

  // task type destinations
  tableModelDestinations: TdoTableModel;
  tableViewDataDestinations: TableViewDataDestinations[];
  displayedColumnsDestinations: string[] = ['Type', 'Destination', 'actions'];
  displayedColumnsLabelsDestinations: string[] = ['Type', 'Destination'];
  dataSourceDestinations: DataSource<TableViewDataDestinations>;

  isBusy: boolean = false;
  isSaved: boolean = false;
  saveDisabled: boolean = true;
  isEditing: boolean = false;
  isLoading: boolean = false;

  noResults: boolean = true;
  noResultsForLocation: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private globals: Globals,
    private dialogService: DialogService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private taskTypeConfigService: TaskTypeConfigurationService,
    private userService: UserService,
    public configurationService: ConfigurationService
  ) { }

  ngOnInit() {
    // get organization type enums
    this.taskTypeConfigService.getEnumValidValueItemsByValidValueName('enumUserTaskType').subscribe((types) => {
      this.taskTypeEnums = types;
    }, err => {
      this.createMessage('Error loading task types', 'Error');
    });

    // get organization type enums
    this.taskTypeConfigService.getEnumValidValueItemsByValidValueName('enumTaskTimeCalculation').subscribe((types) => {
      this.taskTimeCalculationEnums = types;
    }, err => {
      this.createMessage('Error loading task calculations', 'Error');
    });

    this.taskTypeConfigService.getClients().subscribe(data => {
      this.clientList = data;
      const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      if (currentClient) {
        this.selectedClient = currentClient;
      } else {
        this.selectedClient = this.clientList[0];
      }
      this.onChangeClient(this.selectedClient);

      // get users
      this.userService.getUsers(this.selectedClient.TDOCID.toString()).subscribe(udata => {
        if (udata.length > 0) {
          this.users = udata.sort((a, b) => (a.FirstName ? a.FirstName : '').toLocaleLowerCase().localeCompare((b.FirstName ? b.FirstName : '').toLocaleLowerCase()));
        }
      }, err => {
        console.log(err);
        this.isBusy = false;
      });
    }, err => {
      this.isBusy = false;
    });
  }

  onChangeClient(e): void {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeClient(e);
          return;
        } else {
          const tmp = this.selectedClient;
          this.selectedClient = null;
          setTimeout(() => {
            this.selectedClient = tmp;
          }, 20);
        }
      });
    } else {
      this.changeClient(e);
    }
  }

  changeClient(e: TdoClientConfigurationModel) {
    this.selectedClient = e;
    this.isBusy = true;

    // get user groups
    this.userService.getUserGroups(this.selectedClient.TDOCID).subscribe((res1) => {
      if (res1.length > 0) {
        this.userGroups = res1.sort((a, b) => (a.UserGroupName ? a.UserGroupName : '').toLocaleLowerCase().localeCompare((b.UserGroupName ? b.UserGroupName : '').toLocaleLowerCase()));
      }
    });

    this.taskTypeConfigService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
      this.taskTypeList = null;
      this.selectedLocation = null;

      if (this.locationList.length > 0) {
        const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
        if (currentLoc) {
          this.selectedLocation = currentLoc;
        } else {
          this.selectedLocation = this.locationList[0];
        }
        this.onChangeLoc(this.selectedLocation);
      }
      else {

        // no locations returned, clear and disable right side
        this.taskTypeList = [];
        this.locationList = [];
        this.noResults = true;
        this.setToNoResults();
      }
      this.isBusy = false;
    }, err => {
      this.isBusy = false;
    });
  }

  setToNoResults() {
    this.selectedTaskType = new CfgTaskConfigurationListModel();
    this.setSelectedTaskTypeRevert(this.selectedTaskType);
    this.selectedTaskType.TaskDestinations = [];

    this.refreshTableViewData([]);
    this.refreshTableViewDataDestinations([]);

    this.isEditing = false;
    this.saveDisabled = true;
  }

  setSelectedTaskTypeRevert(taskType: CfgTaskConfigurationListModel) {
    this.selectedTaskTypeRevert = new CfgTaskConfigurationListModel();
    this.selectedTaskTypeRevert.TaskCfgID = taskType.TaskCfgID;
    this.selectedTaskTypeRevert.UserTaskType = taskType.UserTaskType;
    this.selectedTaskTypeRevert.TaskTypeCalculation = taskType.TaskTypeCalculation;
    this.selectedTaskTypeRevert.isNew = taskType.isNew;
    this.selectedTaskTypeRevert.isSaved = taskType.isSaved;
    this.selectedTaskTypeRevert.DelayTimeInDays = taskType.DelayTimeInDays;
    this.selectedTaskTypeRevert.LOCID = taskType.LOCID;
    this.selectedTaskTypeRevert.enumTaskTimeCalculationID = taskType.enumTaskTimeCalculationID;
    this.selectedTaskTypeRevert.isManual = taskType.isManual;
    this.selectedTaskTypeRevert.LeadTimeInDays = taskType.LeadTimeInDays;
    this.selectedTaskTypeRevert.enumUserTaskTypeID = taskType.enumUserTaskTypeID;

    // destinations
    const destinations: CfgTaskTypeAutoDestinationListModel[] = [];
    taskType.TaskDestinations.forEach(a => {
      destinations.push(a);
    });
    this.selectedTaskTypeRevert.TaskDestinations = destinations;
  }

  revertSelectedTaskType() {
    this.taskTypeList.forEach(a => {
      if (this.selectedTaskType.TaskCfgID === a.TaskCfgID) {
        a.TaskCfgID = this.selectedTaskTypeRevert.TaskCfgID;
        a.UserTaskType = this.selectedTaskTypeRevert.UserTaskType;
        a.TaskDestinations = this.selectedTaskTypeRevert.TaskDestinations;
        a.TaskTypeCalculation = this.selectedTaskTypeRevert.TaskTypeCalculation;
        a.isNew = this.selectedTaskTypeRevert.isNew;
        a.isSaved = this.selectedTaskTypeRevert.isSaved;
        a.DelayTimeInDays = this.selectedTaskTypeRevert.DelayTimeInDays;
        a.LOCID = this.selectedTaskTypeRevert.LOCID;
        a.enumTaskTimeCalculationID = this.selectedTaskTypeRevert.enumTaskTimeCalculationID;
        a.isManual = this.selectedTaskTypeRevert.isManual;
        a.LeadTimeInDays = this.selectedTaskTypeRevert.LeadTimeInDays;
        a.enumUserTaskTypeID = this.selectedTaskTypeRevert.enumUserTaskTypeID;
      }
    });

    if (this.selectedTaskType) {
      this.selectedTaskTypeDestinations = this.selectedTaskType.TaskDestinations;
      this.refreshTableViewDataDestinations(this.selectedTaskTypeDestinations);
    }
  }

  onChangeLoc(e: ClientLocationDataModel) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeLocation(e);
          return;
        } else {
          const tmp = this.selectedLocation;
          this.selectedLocation = null;
          setTimeout(() => {
            this.selectedLocation = tmp;
          }, 20);
        }
      });
    } else {
      this.changeLocation(e);
    }
  }

  changeLocation(e: ClientLocationDataModel) {
    this.selectedLocation = e;
    this.taskTypeList = null;
    this.isBusy = true;
    this.taskTypeConfigService.getLocationTaskTypes(this.selectedLocation.LOCID.toString()).subscribe(tasks => {
      this.taskTypeList = tasks;
      if (tasks.length > 0)
      {
        this.noResults = false;
        this.selectedTaskType = this.taskTypeList[0];
        this.setSelectedTaskTypeRevert(this.selectedTaskType);

        if (this.selectedTaskType.TaskDestinations) {
          this.selectedTaskTypeDestinations = this.selectedTaskType.TaskDestinations;
        }

        this.refreshTableViewData(this.taskTypeList);
        this.refreshTableViewDataDestinations(this.selectedTaskTypeDestinations);

        if (this.taskTypeList.length > 0) {
          setTimeout(() => {
            this.taskTypeTable.selectRow(this.taskTypeList[0]);
          }, 200);
        }
      }
      else {
        this.refreshTableViewData([]);
        // no tasks returned, clear and disable right side
        // this.selectedTaskType = new CfgTaskConfigurationListModel();
        // this.selectedTaskType.TaskDestinations = [];
        // this.refreshTableViewData([]);
        // this.refreshTableViewDataDestinations([]);
      }
    }, err => {
    });
  }

  // Data change
  refreshTableViewData(models: CfgTaskConfigurationListModel[]): void {
    this.taskTypeList = models;
    this.tableViewData = Array.from(this.taskTypeList, (_) => {
      const model = new TableViewData();
      model.UserTaskType = _.UserTaskType;
      model.model = _;
      return model;
    });
    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'OperatoryName', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.UserTaskType.toLowerCase().includes(filter)) {
          return true;
        }
      };
    } else {
      (this.dataSource as MatTableDataSource<TableViewData>).data = this.tableViewData;
      (this.dataSource as MatTableDataSource<TableViewData>)._updateChangeSubscription();
    }
  }

  refreshTableViewDataDestinations(models: CfgTaskTypeAutoDestinationListModel[]): void {
    this.taskTypeDestinationList = models;
    this.tableViewDataDestinations = Array.from(this.taskTypeDestinationList, (_) => {
      const model = new TableViewDataDestinations();
      model.Type = _.Type;
      model.Destination = _.Destination;
      model.User = _.User;
      model.Destination = _.Destination;
      model.model = _;
      return model;
    });
    if (!this.tableModelDestinations) {
      this.dataSourceDestinations = new MatTableDataSource(this.tableViewDataDestinations);
      this.tableModelDestinations = new TdoTableModel(this.displayedColumnsDestinations, this.displayedColumnsLabelsDestinations, this.dataSourceDestinations, 'OperatoryName', 'asc');
      this.tableModelDestinations.searchPredicate = (data: TableViewDataDestinations, filter: string) => {
        if (data.Destination.toLowerCase().includes(filter)) {
          return true;
        }
      };
    } else {
      (this.dataSourceDestinations as MatTableDataSource<TableViewDataDestinations>).data = this.tableViewDataDestinations;
      (this.dataSourceDestinations as MatTableDataSource<TableViewDataDestinations>)._updateChangeSubscription();
    }
  }

  onTdoTableItemActionClick(event: TdoTableEvent): void {
    switch (event.action) {
      case TdoTableActionsEnum.DELETE:
        const model = (event.value as TableViewData).model;
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.UserTaskType}?`).subscribe((result) => {
          if (result === true) {
            this.taskTypeList = this.taskTypeList.filter(a => a !== model);
            this.selectedTaskType = this.taskTypeList[0];
            this.refreshTableViewData(this.taskTypeList);
            if (this.taskTypeList.length > 0) { this.taskTypeTable.selectRow(this.taskTypeList[0]); }

            // save removal
            this.taskTypeConfigService.removeTaskType(model).subscribe((remove) => {
              if (remove) {
                this.createMessage('Task removed', 'Success');
              }
            });
          }
        });
        break;
    }
  }

  onTdoTableItemActionClickDestination(event: TdoTableEvent): void {
    if (this.isEditing) {
      switch (event.action) {
        case TdoTableActionsEnum.DELETE:
          const model = (event.value as TableViewDataDestinations).model;
          this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.Destination}?`).subscribe((result) => {
            if (result === true) {
              this.taskTypeConfigService.removeTaskAutoDestinationType(model).subscribe(() => {
                this.selectedTaskType.TaskDestinations = this.selectedTaskType.TaskDestinations.filter(a => a !== model);
                this.selectedTaskTypeDestinations = this.selectedTaskType.TaskDestinations;
                this.refreshTableViewDataDestinations(this.selectedTaskTypeDestinations);
              });
            } else {
              //
            }
          });
          break;
      }
    }
  }

  onTdoTableItemClick(event: TdoTableEvent): void {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectItem((event.value as TableViewData).model);
          return;
        } else {
          this.taskTypeTable.selectRow(this.selectedTaskType);
        }
      });
    } else {
      this.selectItem((event.value as TableViewData).model);
    }
  }

  selectItem(model: CfgTaskConfigurationListModel) {
    this.revertSelectedTaskType();

    this.selectedTaskType = model;
    this.setSelectedTaskTypeRevert(this.selectedTaskType);
    this.isEditing = false;
    this.saveDisabled = true;

    this.selectedTaskTypeDestinations = this.selectedTaskType.TaskDestinations;
    this.refreshTableViewDataDestinations(this.selectedTaskTypeDestinations);
  }

  onEdit(event) {
    this.saveDisabled = false;
    this.isEditing = true;
  }

  onSave(event) {

    // testing
    // this.selectedTaskTypeRevert = this.selectedTaskTypeRevert;

    // reset saved vars
    this.isSaved = false;
    this.isLoading = true;

    // save changes to db
    this.taskTypeConfigService.saveTaskType(this.selectedTaskType).subscribe(saved => {
      if (saved)
      {
        // save successful
        this.createMessage('Task saved', 'Success');
        this.isSaved = true;
        this.selectedTaskType = saved;
        this.setSelectedTaskTypeRevert(this.selectedTaskType);
        this.configurationService.setClean();
        // reload task type list
        this.taskTypeConfigService.getLocationTaskTypes(this.selectedLocation.LOCID.toString()).subscribe(tasks => {

          this.taskTypeList = tasks;
          this.refreshTableViewData(this.taskTypeList);

          const selectRow = this.taskTypeList.find(a => a.TaskCfgID === saved.TaskCfgID);
          if (selectRow) {
            this.taskTypeTable.selectRow(selectRow);
            this.selectedTaskType = selectRow;
          }
        }, err => {
        });

        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Error saving task', 'Error');
      this.isLoading = false;
    });
  }

  onCancel(event) {
    this.saveDisabled = true;
    this.isEditing = false;

    // revert changes
    this.revertSelectedTaskType();
  }

  onNew(event) {
    this.addTaskType();
  }

  addTaskType() {
    // revert changes
    this.revertSelectedTaskType();

    const newTask = new CfgTaskConfigurationListModel();
    this.setAllOrgsToIsNewFalse();
    newTask.isNew = true;
    newTask.LOCID = this.selectedLocation.LOCID;
    this.selectedTaskType = newTask;
    this.taskTypeList.push(newTask);

    this.refreshTableViewData(this.taskTypeList);
    const newDestinations: CfgTaskTypeAutoDestinationListModel[] = [];
    this.refreshTableViewDataDestinations(newDestinations);

    this.createMessage('Task added', 'Success');
    this.isSaved = true;

    // simulate edit
    this.saveDisabled = false;
    this.isEditing = true;
    this.setSelectedTaskTypeRevert(this.selectedTaskType);
  }

  setAllOrgsToIsNewFalse() {
    this.taskTypeList.forEach(a => {
      a.isNew = false;
    });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  updateTdoTables() {
    // update table

  }

  onTdoTableDestinationItemActionClick($event: any) {

  }

  onTdoTableDestinationItemClick($event: any) {

  }

  addUserGroup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      groups: this.userGroups,
    };
    dialogConfig.panelClass = 'dialog';

    this.dialog.open(TaskTypeGroupDialogComponent, dialogConfig).afterClosed().subscribe(
      (res: TdoUserGroupConfigurationModel[]) => {
        if (res && res.length > 0) {
          this.configurationService.setDirty();
          res.forEach(a => {
            // add group as destination
            const dest = new CfgTaskTypeAutoDestinationListModel();
            dest.UserGroup = a;
            dest.Destination = a.UserGroupName;
            dest.Type = 'User Group';
            dest.isGroup = true;
            dest.ObjectID = a.UserGroupId;

            if (!this.selectedTaskType.TaskDestinations) { this.selectedTaskType.TaskDestinations = []; }
            this.selectedTaskType.TaskDestinations.push(dest);
          });

          this.selectedTaskTypeDestinations = this.selectedTaskType.TaskDestinations;
          this.refreshTableViewDataDestinations(this.selectedTaskTypeDestinations);
        }
      });
  }

  addUser() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      users: this.users,
    };
    dialogConfig.panelClass = 'dialog';

    this.dialog.open(TaskTypeUserDialogComponent, dialogConfig).afterClosed().subscribe(
      (res: TdoUserConfigurationModel[]) => {
        if (res && res.length > 0) {
          this.configurationService.setDirty();
          res.forEach(a => {
            // add group as destination
            const dest = new CfgTaskTypeAutoDestinationListModel();
            dest.User = a;
            dest.Destination = a.FirstName + ' ' + a.LastName;
            dest.Type = 'User';
            dest.isGroup = false;
            dest.ObjectID = a.UserID;

            if (!this.selectedTaskType.TaskDestinations) { this.selectedTaskType.TaskDestinations = []; }
            this.selectedTaskType.TaskDestinations.push(dest);
          });

          this.selectedTaskTypeDestinations = this.selectedTaskType.TaskDestinations;
          this.refreshTableViewDataDestinations(this.selectedTaskTypeDestinations);
        }
      });
  }
}
